//----------------------------------------------------------
// 0. Helpers
//----------------------------------------------------------

if (navigator.platform == "Win32"){
  document.querySelector("meta[name=viewport]").setAttribute('content', 'width=device-width, initial-scale=' + (1 / window.devicePixelRatio));
}

$(function () {
  $("a").click(function (evt) {
  $('main').addClass('fade');
    evt.preventDefault();
    var link = $(this).attr("href");
    setTimeout(function () {
      window.location.href = link;
    }, 500);
  });
});

const clamp = (num, min, max) => num <= min ? min : num >= max ? max : num;
const map = (x, a, b, c, d) => clamp((x - a) * (d - c) / (b - a) + c, Math.min(c, d), Math.max(c, d));

$('.article-body a').each(function(){
  $(this).attr('data-cursor','');
  $(this).attr('data-cursor-label','');
  $(this).attr('data-cursor-type','md');
});

$('.tiles-cols .tile-item').odd().attr('data-scroll-speed', '1');
$('.tiles-cols .tile-item').even().attr('data-scroll-speed', '3');

$('.tiles-cols-alt .tile-item').even().attr('data-scroll-speed', '1');
$('.tiles-cols-alt .tile-item').odd().attr('data-scroll-speed', '3');

if(window.innerWidth<768){
  $('.col, .list-item').attr('data-scroll','');
}

$('[data-cursor-bg]').each(function(){
  var img = $(this).attr('data-cursor-bg');
  var span = '<span></span>';
  $(this).append(span);
  $(this).find('span').css('background-image','url('+img+')');
});


//----------------------------------------------------------
// 1. Locomotive
//----------------------------------------------------------

// let m = navigator.platform == "Win32" ? 1.3333 : 3;

const scroll = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: true,
  tablet: {smooth: true},
  multiplier: 1.333
  // repeat: true
});

$('.c-scrollbar').attr('data-cursor','').attr('data-cursor-label','drag').attr('data-cursor-type','lg');

scroll.on('scroll', (args) => {
  if (typeof args.currentElements['dark'] === 'object') {
    let progress = args.currentElements['dark'].progress;
    if (progress > 0.1 && progress < 0.86) {
      $('body').addClass('dark');
      $('.logo, .btn-bar').addClass('inv');
    } else {
      $('body').removeClass('dark');
      $('.logo, .btn-bar').removeClass('inv');
    }
  }

  if (typeof args.currentElements['footer'] === 'object') {
    let progress = args.currentElements['footer'].progress;
    // $('.wrapper').css('opacity', progress * 2.4);
    if (progress > 0.45) {
      $('.logo').addClass('ft').css({
        'opacity': '0',
        'pointer-events': 'none',
        'transform': 'translateY(-16px)',
        'transition': '400ms cubic-bezier(.165,.84,.44,1)'
      });
      $('.logo-wrap').css({
        'pointer-events': 'none'
      });
      $('.btn-bar').addClass('inv');
    } else {
      $('.logo').removeClass('ft').css({
        'opacity': '1',
        'pointer-events': 'all',
        'transform': 'translateY(0)',
        'transition': '400ms cubic-bezier(.165,.84,.44,1)'
      });
      $('.logo-wrap').css({
        'pointer-events': 'all'
      });
      $('.btn-bar').removeClass('inv');
    }
  }
});

$('body').imagesLoaded({ background: true })
  .always(function (instance) {
    setTimeout(() => {
      scroll.update();
      document.querySelector('.preloader').classList.add('fade');
      document.querySelector('main').classList.remove('out');
    }, 1000);
  })



//----------------------------------------------------------
// 2. Cursor
//----------------------------------------------------------

if (window.innerWidth > 1024){
  document.body.style.cursor = "none";
}

var cursor = document.querySelector(".cursor");
var cursorBg = cursor.children;
var cursorObj = document.querySelectorAll("[data-cursor]");
var div = document.createElement("div");
div.className = "cursor-label";

document.addEventListener("mousemove", function (e) {
  var x = e.clientX - 40;
  var y = e.clientY - 40;
  gsap.to(cursor, 0.2, { left: x, top: y, ease: "power1" });
});

document.addEventListener("mousedown", function (e) {
  cursor.classList.add('is-down');
});

document.addEventListener("mouseup", function (e) {
  cursor.classList.remove('is-down');
});

cursorObj.forEach(item => {
  var type = item.getAttribute("data-cursor-type");
  var label = item.getAttribute("data-cursor-label");
  var bg = item.getAttribute("data-cursor-bg");
  var text = document.createTextNode(label);

  item.addEventListener("mouseover", () => {
    cursor.classList.add(type ? type : "md");
    if (label.length) {
      div.appendChild(text);
      cursor.appendChild(div);
    }
    bg ? cursorBg[0].style.backgroundImage = "url('" + bg + "')" : cursorBg[0].style.backgroundImage = '';
  });
  item.addEventListener("mouseleave", () => {
    cursor.classList.remove(type ? type : "md");
    if (label.length) {
      div.removeChild(text);
      cursor.removeChild(div);
    }
    bg ? cursorBg[0].style.backgroundImage = '' : cursorBg[0].style.backgroundImage = '';
  });
});



//----------------------------------------------------------
// 3. Magneto
//----------------------------------------------------------

if(window.innerWidth > 1024){
  $('.magneto').each(function () {
    var $this = $(this);

    $(this).mouseenter(function (e) {
      gsap.to(this, 0.3, { transformOrigin: '0 0', scale: 1 });
      gsap.to('.magneto', 0.3, { scale: 1 });
    });

    $(this).mousemove(function (e) {
      callParallax(e);
    });

    $(this).mouseleave(function (e) {
      gsap.to(this, 0.3, { scale: 1 });
      gsap.to($this, 0.3, { scale: 1, x: 0, y: 0 });
    });

    function callParallax(e) {
      parallaxIt(e, $this, 60);
    }

    function parallaxIt(e, target, movement) {
      var boundingRect = $this[0].getBoundingClientRect();
      var relX = e.pageX - boundingRect.left;
      var relY = e.pageY - boundingRect.top;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      gsap.to(target, 0.3, {
        x: (relX - boundingRect.width / 2) / boundingRect.width * movement,
        y: (relY - boundingRect.height / 2 - scrollTop) / boundingRect.width * movement,
        ease: Power2.easeOut
      });
    }
  });
}


//----------------------------------------------------------
// 4. Menu
//----------------------------------------------------------

$('.toggle-menu').on('click', function () {
  if ($('menu.active').length) {
    out = 0;
    setTimeout(() => {
      $(this).removeClass('active');
      $('menu').removeClass('active');
      if($('body').hasClass('dark')){
        $('.logo').addClass('inv');
      } else {
        $('.logo').removeClass('inv');
      }
      if(window.innerWidth<768){
        $('.logo').css('position','absolute');
        $('body').css('overflow','auto');
      }
      if($('.logo').hasClass('ft')){
        $('.logo').css({
          'opacity': '0',
          'pointer-events': 'none',
          'transform': 'translateY(-16px)',
          'transition': '400ms cubic-bezier(.165,.84,.44,1)'
        });
        $('.logo-wrap').css({
          'pointer-events': 'all'
        });
      }
      
    }, 500);

    $('.nav-primary ul li, .nav-secondary ul li').each(function(){
      var li = $(this);
      setTimeout(() => {
        li.addClass('outro');
      }, out += 60);

      setTimeout(() => {
        li.removeClass('intro outro');
      }, 750);
    });
  } else {
    if(window.innerWidth<768){
      $('.logo').css('position','fixed');
      $('body').css('overflow','hidden');
    }
    delay = 150;
    dd = 150;
    $(this).addClass('active');
    $('menu').addClass('active');
    $('.logo').addClass('inv');
    if($('.logo').hasClass('ft')){
      $('.logo').css({
        'opacity': '1',
        'pointer-events': 'all',
        'transform': 'translateY(0)',
        'transition': '400ms cubic-bezier(.165,.84,.44,1)'
      });
      $('.logo-wrap').css({
        'pointer-events': 'all'
      });
    }
    
    $('.nav-primary ul li').each(function(){
      var li = $(this);
      li.removeClass('outro');

      setTimeout(function () {
        li.addClass('intro');
      }, delay += 120);
    });

    $('.nav-secondary ul li').each(function(){
      var li = $(this);
      li.removeClass('outro');

      setTimeout(function () {
        li.addClass('intro');
      }, dd += 90);
    });
  }
});

// target
$('.nav-primary ul li a').each(function(){
  var parent = $('.nav-primary').offset().top;

  $(this).on('mouseover', function(){
    var h = $(this).outerHeight();
    var t = $(this).offset().top;
    var pos = t-(h/2);
    $('.target').addClass('active').css('top', pos - parent);
  });

  $(this).on('mouseout', function(){
    $('.target').removeClass('active');
  });
});

$('nav a').on('click', function(){
  $('.toggle-menu').trigger('click');
})

//----------------------------------------------------------
// 5. Reel
//----------------------------------------------------------

$('.reel-item').each(function(){
  $this = $(this);
  var content = $(this).attr('data-reel');

  (function () {
    for (var i = 0; i < 5; i++) {
      var item = $('<li>' + content + '</li>');
      $this.append(item);
    }
  })();

  var random = Math.floor(Math.random() * 4);
  if(window.innerWidth>768){
    $this.find('li').eq(random).css("opacity", "1");
  } else {
    $this.find('li').even().css("opacity", "1");
  }

});



//----------------------------------------------------------
// 6. Splitting & Locomotive
//----------------------------------------------------------


var sp = $('[data-splitting]');

if(sp.length && window.innerWidth>768){
  const splitting = Splitting();
  let sscroll = { cache: 0, current: 0 };

  scroll.on('scroll', obj => {
    sscroll.current = obj.scroll.y;
    const distance = sscroll.current - sscroll.cache;
    sscroll.cache = sscroll.current;
    const transformVal = {
      translateY: map(distance, 300, -300, -40, 40)
    };
    for (const [_, word] of splitting.entries()) {
      const charsTotal = word.chars.length;
      for (const [j, char] of word.chars.entries()) {
        const factor = j < Math.ceil(charsTotal / 2) ? j : Math.ceil(charsTotal / 2) - Math.abs(Math.floor(charsTotal / 2) - j) - 1;
        char.style.transform = `translate3d(0,${factor * transformVal.translateY}px,0)`;
      }
    }
  });
} 


//----------------------------------------------------------
// 7. listing BG
//----------------------------------------------------------
if($('.listing').length){
  $('body').append('<div class="listing-bg"></div>');
}
$('.listing ul li').each(function(){
  var url = $(this).attr('data-img');  
  var img = '<img src='+url+' alt="person">';
  $('.listing-bg').append(img);

  $(this).on('mouseover', function(){
    var index = $(this).index();
    $('.listing-bg img#img'+index).addClass('intro')
  }).on('mouseout', function(){
    var index = $(this).index();
    $('.listing-bg img#img'+index).removeClass('intro');
  });
});

$('.listing-bg').each(function(){
  var img = $(this).find('img');
  
  id=0;
  img.each(function(){
    $(this).attr('id','img'+id);
    id++;
  });
});


//----------------------------------------------------------
// 8. Form
//----------------------------------------------------------

$('.input-default, .textarea-default').after('<span class="input-border"></span>');

$('.input-default, .textarea-default').each(function(){
  var tt = $(this);
  var obj = tt.siblings();
  var br = tt.siblings('.input-border');

  if (tt.val().length) {
    tt.addClass('active');
    obj.addClass('active');
    br.addClass('active-blur');
  } else {
    tt.removeClass('active');
    obj.removeClass('active');
  }
});

$('.input-default, .textarea-default').on('focus', function(){
  var obj = $(this).siblings();
  var br = $(this).siblings('.input-border');

  if ($(this).val().length) {
    $(this).addClass('active');
    obj.addClass('active');
    br.removeClass('active-blur').addClass('active');
  } else {
    $(this).addClass('active');
    obj.addClass('active');
  }
});

$('.input-default, .textarea-default').on('blur', function(){
  var obj = $(this).siblings();
  var br = $(this).siblings('.input-border');

  if ($(this).val().length) {
    $(this).addClass('active');
    obj.addClass('active');
    br.addClass('active-blur');
  } else {
    $(this).removeClass('active');
    obj.removeClass('active');
  }
});

// update scroll
var ta = $(".textarea-default");
var width = ta.outerWidth(), height = ta.outerHeight()
$(".textarea-default").on("mouseup", function () {
  if (ta.outerWidth() != width || ta.outerHeight() != height) {
    scroll.update();
  }
  width = ta.outerWidth();
  height = ta.outerHeight();
});

//file input
var input = document.getElementById('upload');
if (input){
  input.onchange = function () {
    var fullPath = input.value;
    if (fullPath) {
      var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
      var filename = fullPath.substring(startIndex);
      if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
        filename = filename.substring(1);
      }
      $('.label-text').text(filename);
      $('.clear-attachment').addClass('active');
    }
  };
}

$('.clear-attachment').on('click', function(){
  input.value = null;
  $('.label-text').text('Attach your CV');
  $('.clear-attachment').removeClass('active');
});

// button text
$('.btn-primary').each(function(){
  var text = $(this).attr('data-text');
  var span = '<span>'+text+'</span>';

  $(this).append(span);
});

$('.btn-checkbox').each(function(){
  var lab = $(this).find('.lab');
  var text = lab.attr('data-text');
  var span = '<span>' + text + '</span>';

  lab.append(span);
});

var required = $('form input[required], form textarea[required]');

(function() {
  required.keyup(function() {
    var empty = false;
    required.each(function() {
      if ($(this).val() == '') {
        empty = true;
      }
    });

    if (empty) {
      $('.btn-submit').addClass('btn-disabled');
    } else {
      $('.btn-submit').removeClass('btn-disabled');
    }
  });
})()

$('.btn-submit').find('span').append('<div><i class="far fa-spinner-third fa-spin"></i></div>');

if($('form').length){
  var r = '<div class="toast"><p></p></div>';
  $('body').append(r);
}

$("#form").on('submit', function (e) {
  e.preventDefault();
  $('.btn-submit').trigger('blur').addClass('btn-loader');
  $('.btn-submit span div').addClass('active');
  var url = $(this).attr('action');
  var type = $(this).attr('method');
  $.ajax({
    type: type,
    url: url,
    data: $(this).serialize(),
    success: function (data) {
      $('.toast p').text(data);
      $('.toast').addClass('in');
      $('.btn-submit').removeClass('btn-loader');
      $('.btn-submit span div').removeClass('active');
      
      $('#form').trigger('reset');
      $('.input-default, .textarea-default').trigger('blur');
      required.trigger('keyup');
      $('.clear-attachment').trigger('click');

      setTimeout(() => {
        $('.toast').removeClass('in');
      },3800);
    }
  });

});



//----------------------------------------------------------
// 9. Dropdown
//----------------------------------------------------------

$('.dropdown').each(function(){
  var btn = $(this).find('.dropdown-btn');
  var content = $(this).find('.dropdown-content');
  var ov = content.find('.overlay');
  var li = content.find('ul li');
  
  li.each(function(){
    var span = '<span>'+$(this).find('h2').attr('data-text')+'</span>';
    // var h2 = li.each().find('h2');
    // var span = '<span>'+h2.attr('data-text')+'</span>';

    $(this).find('h2').append(span);
  });
  content.wrapInner('<div class="content-wrapper"></div>');
  
  btn.on('click', function(){
    content.addClass('active');

    delay = 0;

    li.each(function () {
      var li = $(this);
      li.removeClass('outro');

      setTimeout(function () {
        li.addClass('intro');
      }, delay += 80);
    });
  });

  ov.on('click', function(){
    content.removeClass('active');

    out = 0;

    li.each(function () {
      var li = $(this);
      setTimeout(() => {
        li.addClass('outro');
      }, out += 40);

      setTimeout(() => {
        li.removeClass('intro outro');
      }, 500);
    });
  });
});



//----------------------------------------------------------
// 10. Filtering
//----------------------------------------------------------

$('[data-filter]').each(function(){
  var $this = $(this);
  var txt = $this.find('h2').text();
  var filterValue = $(this).attr('data-filter');
  var all = $(this).find('[data-filter="*"]');
  var icon = '<i class="far fa-angle-down"></i>';

  $this.on('click', function(){
    $('.tile-item').show();
    $('.tiles-cols-alt').filter(function(){
      $('.tile-item:not(' + filterValue + ')').hide();

      $('.overlay').trigger('click');
      $('.dropdown-btn h2').text(txt).append(icon);

      $('.tiles-cols-alt .tile-item'+filterValue).odd().attr('data-scroll-speed', '3');
      $('.tiles-cols-alt .tile-item'+filterValue).even().attr('data-scroll-speed', '1');
      scroll.update();
    });
  });

  all.on('click', function(){
    $('.overlay').trigger('click');
    $('.dropdown-btn h2').text(txt).append(icon);
    $('.tiles-cols-alt').removeClass('filtering');
    $('.tile-item').show();
    $('.tiles-cols-alt .tile-item'+filterValue).odd().attr('data-scroll-speed', '3');
    $('.tiles-cols-alt .tile-item'+filterValue).even().attr('data-scroll-speed', '1');
          
    scroll.update();
  });
});

